<!--
 * @Author: liushumin
 * @Date: 2022-09-07 09:10:36
 * @LastEditTime: 2022-09-07 09:25:03
 * @LastEditors: liushumin
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "Szoperation",
};
</script>
